//External Import
const LazyLoader = () => {
  return (
    <div className="loading__overlay">
      <div className="indeterminate"></div>
    </div>
  );
};

export default LazyLoader;
